import { create } from "zustand";

import { OnBoardingNewPatientData } from "../utils/patientOnBoardings/types";

export interface OnBoardingNewPatientStoreState {
  newPatient?: OnBoardingNewPatientData;
  setNewPatient(newPatient?: OnBoardingNewPatientData): void;
  currentStep: number;
  nextStep(): void;
  previousStep(): void;
  skipStep(amountToSkip: number): void;
  resetStep(): void;
}

export const useOnBoardingNewPatientStore =
  create<OnBoardingNewPatientStoreState>()((set, get) => ({
    newPatient: undefined,
    setNewPatient: (newPatient?: OnBoardingNewPatientData) => {
      set(() => ({ newPatient }));
    },
    currentStep: 0,
    resetStep: () => {
      set(() => ({
        currentStep: 0,
      }));
    },
    nextStep: () => {
      const step = get().currentStep;
      set(() => ({
        currentStep: step + 1,
      }));
    },
    previousStep: () => {
      const step = get().currentStep;
      set(() => ({
        currentStep: step - 1,
      }));
    },
    skipStep: (amountToSkip: number) => {
      const step = get().currentStep;
      set(() => ({
        currentStep: step + amountToSkip,
      }));
    },
  }));
